module.exports = __webpack_public_path__ + "static/media/otras-areas-mediana.322f6208.jpg";